import React, { useState, Fragment, useContext } from 'react';
import ContactUsRequest from './ContactUsRequest';
import GrayInfoBox from './GrayInfoBox';
import { TranslationContext } from "./Context";

function ContactUs(props) {

    const translation = useContext(TranslationContext);
    const [contactUsSent, setContactUsSent] = useState(false);

    function handleSent(e) {
        setContactUsSent(true);
    }

    return (
        <Fragment>
            {!contactUsSent &&
                <ContactUsRequest onSent={handleSent} vehicle={props.vehicle} />}
            {contactUsSent &&
                <GrayInfoBox>
                    <h2 className="u-textBold28">{translation["TecAlliencePartSearch.ContactUs.ThankYouForContactingUs"]}</h2>
                    <div className="u-mbottom20">{translation["TecAlliencePartSearch.ContactUs.ThankYouForContactingUsExtraInformation"]}</div>
                    <button className="btn btn-primary" onClick={props.onCloseClick}>{translation["TecAlliencePartSearch.ContactUs.Close"]}</button>
                </GrayInfoBox>}
        </Fragment>
    );
}
export default ContactUs;